import {ReactElement, useState} from "react";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import {Link, useParams} from "react-router-dom";
import {useSearchEquityTransactions} from "../../application/EquityTransactionService";
import {EquityTransaction} from "../../domain/transaction/EquityTransaction";
import {PageDto} from "../../domain/PageDto";
import TransactionSearchBar, {TransactionSearchFields} from "./TransactionSearchBar";
import {SearchDataFunction} from "../../components/types/SearchDataFunction";
import {TransactionSearchTerm} from "../../domain/transaction/TransactionSearchTerm";
import {SyncProblemRounded} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import EquityTransactionComponent from "../../components/EquityTransactionComponent";
import {Collapse, Tooltip} from "@mui/material";

export default function EquityTransactions(): ReactElement {
    const params = useParams();
    let initialSearchTerm: TransactionSearchTerm | null = null;
    if (params.assetManager && params.transactionId) {
        initialSearchTerm = {
            counterpart: '',
            fromDate: null,
            toDate: null,
            instrument: '',
            states: [],
            transaction: params.transactionId,
            assetManager: params.assetManager
        };
    }
    const searchFn: SearchDataFunction<TransactionSearchTerm, PageDto<EquityTransaction>> = useSearchEquityTransactions(initialSearchTerm);
    const [ searchExpanded, setSearchExpanded ] = useState<boolean>(false);

    return (
        <Container maxWidth={ false } sx={{ mt: 4, mb: 4 }}>
            { <Toolbar/> }
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2
                }}>
                <Grid size={{ xs: 12, md: 5, lg: 5 }}>
                    <Title>Equity Transactions</Title>
                </Grid>
                <Grid size={{ xs: 12, md: 1, lg: 1 }}>
                    <Tooltip title={"View not confirmed transactions"} placement={"top"}>
                        <span>
                            <IconButton component={Link} to="/transaction/eq/active">
                                <SyncProblemRounded />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Grid>
                <TransactionSearchBar searchFn={ searchFn } expanded={searchExpanded} onToggle={setSearchExpanded}/>
            </Grid>
            <Collapse in={searchExpanded} timeout="auto" unmountOnExit>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                        <TransactionSearchFields searchFn={ searchFn }/>
                    </Grid>
                </Grid>
            </Collapse>
            <Grid container spacing={2}>
                <EquityTransactionComponent searchFn={searchFn}/>
            </Grid>
        </Container>
    );
}